import { render, staticRenderFns } from "./BoxError.vue?vue&type=template&id=219f17d5&scoped=true&"
import script from "./BoxError.vue?vue&type=script&lang=ts&"
export * from "./BoxError.vue?vue&type=script&lang=ts&"
import style0 from "./BoxError.vue?vue&type=style&index=0&id=219f17d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219f17d5",
  null
  
)

export default component.exports